import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { FascicoloLight } from 'src/app/common/models/fascicolo/fascicolo-light';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { RoutingConfigurationUtilService } from 'src/app/core/services/routing-configuration-util.service';
import { CssClassMapping } from "../../../../core/configuration/css-class-mapping";
import { FrontEndMapping } from "../../../../core/configuration/front-end-mapping";
import { OperationsService } from "../../../../core/services/operations.service";
import { SearchResponse } from "../../../models/dto/search-response";
import { PraticaSelect } from "../../../models/pratica/intestazione-pratica/pratica-select";
import { PraticaBase } from "../../../models/pratica/pratica-base";
import { SearchPraticheComponent } from "../../input-component/searchPratiche/search-pratiche.component";

declare var getPraticaMapSync: any;

@Component({
  selector: 'app-pratiche-correlate-create',
  templateUrl: './pratiche-correlate-create.component.html',
  styleUrls: ['./pratiche-correlate-create.component.css']
})
export class PraticheCorrelateCreateComponent implements OnInit {
  private _pratiche: PraticaSelect[];
  @ViewChild('searchPratiche') searchPraticheComponent: SearchPraticheComponent;
  @Output() praticheChange = new EventEmitter<PraticaSelect[]>();
  @Input() get pratiche(): PraticaSelect[] { return this._pratiche; }
  set pratiche(d: PraticaSelect[]) {
    this._pratiche = d;
    this.praticheChange.emit(this._pratiche);
  }
  // pratiche: PraticaSelect[];
  pratica: PraticaBase;
  urlCorrelaPratiche: string;
  private tipoPratica: string;
  private searchResponse: SearchResponse;
  onPageCorrela: boolean = false;
  // @Output() onReturn: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private operations: OperationsService, private router: Router, private frontEndMapping: FrontEndMapping, private routingService: RoutingConfigurationUtilService ) {
  }

  ngOnInit() {
    if (this.router.url.indexOf('pratiche_correlate') !== -1) {
      this.onPageCorrela = true;
    } else {
      this.onPageCorrela = false;
    }
  }

  getTipoPratica(pratica: PraticaBase) {
    let tipoPratica = '';
    this.frontEndMapping.getListTipiPratica(pratica.tipoPratica.id).subscribe(res => {
      tipoPratica = res;
    });
    return tipoPratica;
    // return FrontEndMapping.tipiPratica[pratica.tipoPratica.id];
  }

  getClassPratica(idTipoPratica) {
    return CssClassMapping.cssTipiPratica[idTipoPratica];
  }

  inizializza(pratica: PraticaBase) {
    this.pratiche = [];
    this.pratica = pratica;
    let praticaMap = this.getPraticaFromMap(this.pratica.tipoPratica.id);
    this.urlCorrelaPratiche = praticaMap.pathCorrela;
    this.frontEndMapping.getListTipiPratica(this.pratica.tipoPratica.id).subscribe(res => {
      this.tipoPratica = res; // FrontEndMapping.tipiPratica[this.pratica.tipoPratica.id];
    });
  }

  public updatePraticheList(result: PraticaSelect[]) {
    if (result) {
      this.pratiche = this.pratiche.concat(result);
    }
  }

  public refresh(searchResponse,  reload: boolean = false) {
    this.searchResponse = searchResponse;
    if (searchResponse) {
      if (!reload) {
        this.pratiche = new Array<PraticaSelect>();
      }
      // let pratiche_tmp = searchResponse.pratiche.filter(obj => obj.id != this.pratica.id);
      this.updatePraticheList(searchResponse.pratiche);
      // this.pratiche = this.pratiche.concat(<PraticaSelect>pratiche_tmp);
    } else {
      this.pratiche = new Array<PraticaSelect>();
    }
  }

  reset() {
    for (let i = 0; i < this.pratiche.length; i++) {
      if (this.pratiche[i].selected) {
        this.pratiche[i].selected = false;
      }
    }
  }

  getRoutingPath(fascicolo, pratica): string {
    let path: string;
    path = this.routingService.checkStatoFascicoloAndGetRoutingPath(fascicolo, pratica.tipoPratica.id, fascicolo.tipoFascicolo.id);
    return path;
  }

  getCssClassCategoriaFascicolo(fascicolo: FascicoloLight) {
    if(fascicolo.tipoFascicolo && fascicolo.tipoFascicolo.categoria){   
      let categoriaMap = CssClassMapping.cssTipiCategoriaFascicolo[fascicolo.tipoFascicolo.categoria.id];
      return categoriaMap;
    }
  }

  private getPraticaFromMap(idTipoPraticaMap: any) {
    // let nomePraticaFE = FrontEndMapping.tipiPratica[idTipoPraticaMap];
    let pratica = getPraticaMapSync(idTipoPraticaMap);
    return pratica;
  }

  reloadSearch() {
    this.searchPraticheComponent.reloadCallback(this.pratiche.length);
  }


  getPraticaPathFromType(pratica: PraticaBase) {
    let tipoPratica = '';
    this.frontEndMapping.getListTipiPratica(pratica.tipoPratica.id).subscribe(res => {
      tipoPratica = res;
    });
    return tipoPratica;
    // return FrontEndMapping.tipiPratica[pratica.tipoPratica.id];
  }

  getPraticaViewPath() {
    return ServicePathsSettings.VIEW_LABEL;
  }

}
